import React from 'react'

import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const Loading = () => (
  <Spin size="small" indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
)
export default Loading
